import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=5368c03b&scoped=true"
import script from "./SubmitOrder.vue?vue&type=script&lang=ts"
export * from "./SubmitOrder.vue?vue&type=script&lang=ts"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=5368c03b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368c03b",
  null
  
)

export default component.exports